import { render, staticRenderFns } from "./CommunityBusinessnewsUpdate.vue?vue&type=template&id=1428cdd2&"
import script from "./CommunityBusinessnewsUpdate.vue?vue&type=script&lang=js&"
export * from "./CommunityBusinessnewsUpdate.vue?vue&type=script&lang=js&"
import style0 from "./CommunityBusinessnewsUpdate.vue?vue&type=style&index=0&id=1428cdd2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports